var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('kit-general-10v1')],1)])]),_c('div',{staticClass:"col-xl-8 col-lg-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('userInformation')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }